import type { Faq, FaqAnswer } from '../types/content'

// The live site currently shows this same process answer under every question.
const processAnswer: FaqAnswer = {
  intro: 'Working with us is pretty straightforward. Here is the process you can expect from us:',
  steps: [
    {
      title: 'Initial Consultation',
      body: 'We start by scheduling an initial consultation to understand specific requirements and needs. This allows us to gain insights into your brand, target audience, and understand issues and needs.',
    },
    {
      title: 'Planning and Proposal',
      body: 'Based on the information, our team will create a project plan and proposal. This will outline the scope of work, timeline, and cost estimates for the project.',
    },
    {
      title: 'UX/UI Design and 3D assets',
      body: 'After approval, we begin with UX/UI design and 3D/illustrations, working closely with you to seek feedback and to ensure that the final designs align with our expectations.',
    },
    {
      title: 'Web Development',
      body: 'Using webflow we put all pieces together and develop a fully functional website. Once we completed the 1 to 1 implementation, we add responsiveness, animations and custom functionality to the site.',
    },
    {
      title: 'Testing and Launch',
      body: 'Before the final launch, we conduct testing to make the website function without problems across different devices and browsers. We address any issues or bugs identified during the testing phase, to ensure that the experience is smooth.',
    },
    {
      title: 'Ongoing Support',
      body: "We set your website live without any hickups and provide ongoing support to ensure it stays operational, secure and optimized. When it does brake down or one of your devs accidently publishes work in progress, we fix it and get it up and running again quickly without making a big fuss about it – If your company's dignity is at stake, you can even call us on weekends.",
    },
  ],
}

export const faqs: Faq[] = [
  { question: 'What process does your Agency follow?', answer: processAnswer },
  { question: 'Can you build a modern website for my marketing campaign?', answer: processAnswer },
  { question: 'Can you redesign my enterprise website?', answer: processAnswer },
  { question: 'Can I hire you to design individual assets?', answer: processAnswer },
  { question: 'How much do your services cost?', answer: processAnswer },
]
